import { defineMessages } from 'react-intl';

/** The copy of the limit upsell card (design limit-upsell a1-a12). */
export const limitUpsellMessages = defineMessages({
  titlePlanPosts: {
    id: 'app.sml.limitUpsell.title.planPosts',
    defaultMessage:
      'This plan needs {needed, plural, one {# post} other {# posts}}. You have {left, number} left in {month}.',
  },
  titlePostPosts: {
    id: 'app.sml.limitUpsell.title.postPosts',
    defaultMessage:
      'This post needs {needed, plural, one {# post} other {# posts}}. You have {left, number} left in {month}.',
  },
  titlePlanCredits: {
    id: 'app.sml.limitUpsell.title.planCredits',
    defaultMessage:
      'This plan needs {needed, plural, one {# video credit} other {# video credits}}. You have {left, number} left.',
  },
  titleRefusedPosts: {
    id: 'app.sml.limitUpsell.title.refusedPosts',
    defaultMessage:
      '{count, plural, one {# post did not fit {month}. It stays a draft.} other {# posts did not fit {month}. They stay drafts.}}',
  },
  subAddOnPlanPosts: {
    id: 'app.sml.limitUpsell.sub.addOnPlanPosts',
    defaultMessage: 'The posts that you schedule now use the posts of this month. Add posts, or plan only what fits.',
  },
  subAddOnPostPosts: {
    id: 'app.sml.limitUpsell.sub.addOnPostPosts',
    defaultMessage: 'Each channel takes one post. Add posts, or save it as a draft.',
  },
  subAddOnRefusedPosts: {
    id: 'app.sml.limitUpsell.sub.addOnRefusedPosts',
    defaultMessage: 'Add posts, then schedule them again.',
  },
  subAddOnCredits: {
    id: 'app.sml.limitUpsell.sub.addOnCredits',
    defaultMessage: 'Add credits to the plan, buy a pack, or plan only what fits.',
  },
  subPlansPosts: {
    id: 'app.sml.limitUpsell.sub.plansPosts',
    defaultMessage: 'A paid plan gives you more posts each month.',
  },
  subPlansCredits: {
    id: 'app.sml.limitUpsell.sub.plansCredits',
    defaultMessage: 'A paid plan gives you more video credits each month.',
  },
  subHigherPosts: {
    id: 'app.sml.limitUpsell.sub.higherPosts',
    defaultMessage: 'A higher plan gives you more posts each month. Add-ons are sold with web plans only.',
  },
  subHigherCredits: {
    id: 'app.sml.limitUpsell.sub.higherCredits',
    defaultMessage: 'A higher plan gives you more video credits each month. Add-ons are sold with web plans only.',
  },
  subAskOwnerPosts: {
    id: 'app.sml.limitUpsell.sub.askOwnerPosts',
    defaultMessage: 'Ask the workspace owner to add posts.',
  },
  subAskOwnerCredits: {
    id: 'app.sml.limitUpsell.sub.askOwnerCredits',
    defaultMessage: 'Ask the workspace owner to add video credits.',
  },
  legendLeft: { id: 'app.sml.limitUpsell.legend.left', defaultMessage: '{count, number} left' },
  legendShort: { id: 'app.sml.limitUpsell.legend.short', defaultMessage: '{count, number} short' },
  addPostsMonth: {
    id: 'app.sml.limitUpsell.add.postsMonth',
    defaultMessage: 'Add {count, number} posts a month for {price}',
  },
  addPostsYear: {
    id: 'app.sml.limitUpsell.add.postsYear',
    defaultMessage: 'Add {count, number} posts a month for {price} a year',
  },
  addCreditsMonth: {
    id: 'app.sml.limitUpsell.add.creditsMonth',
    defaultMessage: 'Add {count, number} credits a month for {price}',
  },
  addCreditsYear: {
    id: 'app.sml.limitUpsell.add.creditsYear',
    defaultMessage: 'Add {count, number} credits a month for {price} a year',
  },
  otherAmount: { id: 'app.sml.limitUpsell.otherAmount', defaultMessage: 'Choose another amount' },
  seePlans: { id: 'app.sml.limitUpsell.seePlans', defaultMessage: 'See plans' },
  fitDefault: { id: 'app.sml.limitUpsell.fit', defaultMessage: 'Plan only what fits' },
  confirmPosts: { id: 'app.sml.limitUpsell.confirm.posts', defaultMessage: 'Add {count, number} posts a month?' },
  confirmCredits: {
    id: 'app.sml.limitUpsell.confirm.credits',
    defaultMessage: 'Add {count, number} credits a month?',
  },
  rowAddOns: { id: 'app.sml.limitUpsell.confirm.rowAddOns', defaultMessage: 'Add-ons' },
  rowTotal: { id: 'app.sml.limitUpsell.confirm.rowTotal', defaultMessage: 'New total' },
  perMonth: { id: 'app.sml.limitUpsell.confirm.perMonth', defaultMessage: '{price} a month' },
  perYear: { id: 'app.sml.limitUpsell.confirm.perYear', defaultMessage: '{price} a year' },
  confirmNote: {
    id: 'app.sml.limitUpsell.confirm.note',
    defaultMessage:
      'You get them now. Today we charge only the part of the billing period that is left. You can change the add-ons at any time in Settings → Subscription.',
  },
  confirmAddPosts: { id: 'app.sml.limitUpsell.confirm.addPosts', defaultMessage: 'Add {count, number} posts' },
  confirmAddCredits: { id: 'app.sml.limitUpsell.confirm.addCredits', defaultMessage: 'Add {count, number} credits' },
  cancel: { id: 'app.sml.limitUpsell.confirm.cancel', defaultMessage: 'Cancel' },
  adding: { id: 'app.sml.limitUpsell.confirm.adding', defaultMessage: 'Adding' },
  addedPosts: {
    id: 'app.sml.limitUpsell.added.posts',
    defaultMessage: '{count, number} posts added to your plan each month.',
  },
  addedCredits: {
    id: 'app.sml.limitUpsell.added.credits',
    defaultMessage: '{count, number} video credits added to your plan each month.',
  },
  addFailed: {
    id: 'app.sml.limitUpsell.addFailed',
    defaultMessage: 'We could not change your add-ons. Try again.',
  },
});
